var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 35,
    viewBox: "0 0 41 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4167 1.76339C38.4167 1.76339 37.1333 5.61339 34.75 7.99672C37.6833 26.3301 17.5167 39.7134 1.75 29.2634C5.78333 29.4467 9.81667 28.1634 12.75 25.5967C3.58333 22.8467 -1 12.0301 3.58333 3.59672C7.61667 8.36339 13.85 11.1134 20.0833 10.9301C18.4333 3.23005 27.4167 -1.16995 32.9167 3.96339C34.9333 3.96339 38.4167 1.76339 38.4167 1.76339Z",
    stroke: "#4771FE",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.bce68187292d1123f6123cfb7e37577a.svg";
export { ForwardRef as ReactComponent };